import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';

@Component({
    selector: 'app-pb-institute-level-breakdown',
    templateUrl: './pb-institute-level-breakdown.component.html',
    styleUrls: ['./pb-institute-level-breakdown.component.scss']
})
export class PbInstituteLevelBreakdownComponent implements OnInit {

    @Input() module: any = {};
    padding_top: any = '';
    padding_bottom: any = '';
    @Input() id: any = 0;

    step: any;
    payMethod: string = 'now';
    course: any = {};
    levels: any = 0;
    subjects: any = 0;
    items: any = [];
    localSubjects: any = []; // Comes from our api not catalyst

    institution: any = {};
    institutionLoaded: boolean = false;
    subjectsLoaded: boolean = false;

    constructor(
        private api: ApiService,
        private cd: ChangeDetectorRef
    ) {

    }

    ngOnInit(): void {

        this.padding_top = this.module.padding_top; // Module Padding
        this.padding_bottom = this.module.padding_bottom;

        this.fetchInstitution();

    }

    /**
     * Padding is returned as SMALL, MEDIUM, LARGE, XLARGE
     * Determine pixels based on response
     */
    determinePadding(padding) {

        if (padding == 'SMALL') {
            return '10';
        } else if (padding == 'MEDIUM') {
            return '15';
        } else if (padding == 'LARGE') {
            return '30';
        } else if (padding == 'XLARGE') {
            return '60';
        }

    }

    /**
     * Fetch the institution before fetching the courses
     */
    async fetchInstitution() {

        await this.api.fetch_institution(this.id)
            .subscribe(res => {
                this.institution = res.data.item;
                this.institutionLoaded = true;

                this.fetchCourses();
            }, (err) => {

            });

    }

    /**
     * Fetch all courses.
     * This data is then passed to parseRawData function which in turn is used to build the sidemenu
     */
    async fetchCourses() {

        await this.api.fetch_course_list()
            .subscribe(res => {
                let index = res.Result?.Course.findIndex(x => x.CourseKey._text == this.id);
                if (index !== -1) {
                    this.course = res.Result?.Course[index];
                }

                this.items = [];
                this.levels = this.course.SubjectLevels?.SubjectLevel.length;

                this.course.SubjectLevels.SubjectLevel = this.ensureArray(
                    this.course.SubjectLevels?.SubjectLevel
                );

                this.course.SubjectLevels?.SubjectLevel?.forEach(element => {
                    let temp = {};
                    temp['SubjectLevelKey'] = element.SubjectLevelKey;
                    temp['SubjectLevelName'] = element.SubjectLevelName;
                    temp['WebsiteAwardDescription'] = element.WebsiteAwardDescription._text;
                    temp['Subjects'] = [];

                    if (Array.isArray(element.Subjects.Subject)) {
                        this.subjects += element.Subjects.Subject.length;
                        temp['Subjects'] = element.Subjects;
                    } else {
                        this.subjects++;
                        temp['Subjects']['Subject'] = [];
                        temp['Subjects']['Subject'].push(element.Subjects.Subject);
                    }

                    let levelIndex = this.institution.levels.findIndex(x => x.identifier == element.SubjectLevelKey._text);
                    if (levelIndex !== -1) {
                        temp['SubjectLevelCustomTitle'] = this.institution.levels[levelIndex].title;
                        temp['Priority'] = this.institution.levels[levelIndex].priority;
                    } else {
                        temp['SubjectLevelCustomTitle'] = '';
                        temp['Priority'] = '';
                    }

                    this.items.push(temp);
                });


                this.items.sort(function (a, b) {
                    if (a.Priority < b.Priority)
                        return -1;
                    if (a.Priority > b.Priority)
                        return 1;
                    return 0;
                });

                if (this.course.SubjectLevels !== undefined) {
                    this.course.SubjectLevels.SubjectLevel = this.items;
                }

                this.fetchSubjects();
            }, (err) => {

            });

    }



    /**
     * Fetches Subject Products based on courseKey
     * Used to build the main grid of items
     */
    async fetchSubjects() {

        await this.api.fetch_subjects()
            .subscribe(res => {
                this.localSubjects = res.data.items;

                this.course.SubjectLevels.SubjectLevel = this.ensureArray(
                    this.course.SubjectLevels?.SubjectLevel
                );

                this.course.SubjectLevels?.SubjectLevel.forEach(element => {
                    element.Subjects.Subject.forEach(subject => {
                        let index = this.localSubjects.findIndex(x => x.identifier == subject.SubjectKey._text);
                        if (index !== -1) {
                            subject.slug = this.localSubjects[index].slug;
                            subject.exam_type = JSON.parse(this.localSubjects[index].exam_type);
                            subject.exam_type = subject.exam_type?.replace(/(<([^>]+)>)/ig, '');
                            subject.title = this.localSubjects[index].title;
                            subject.content = JSON.parse(this.localSubjects[index].content);
                            subject.content = subject.content?.replace(/(<([^>]+)>)/ig, '');
                        } else {
                            subject.slug = '';
                            subject.title = '';
                            subject.exam_type = '';
                            subject.content = '';
                        }
                    });
                });

                this.subjectsLoaded = true;
                this.cd.detectChanges();
            }, (err) => {
                this.subjectsLoaded = true;
            });

    }

    /**
     * Slugify a string. Used with the study method name
     * @param str 
     * @returns 
     */
    slugify(str) {
        str = this.replaceAccents(str);
        str = this.removeNonWord(str);
        str = str.replace(/ +/g, '-') // replace spaces with delimiter
            .toLowerCase();

        return str;
    }

    /**
     * Remove non-word chars.
     */
    removeNonWord(str) {
        return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, '');
    }

    /**
     * Replaces all accented chars with regular ones
     */
    replaceAccents(str) {
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                .replace(/[\xC0-\xC5]/g, 'A')
                .replace(/[\xC6]/g, 'AE')
                .replace(/[\xC7]/g, 'C')
                .replace(/[\xC8-\xCB]/g, 'E')
                .replace(/[\xCC-\xCF]/g, 'I')
                .replace(/[\xD0]/g, 'D')
                .replace(/[\xD1]/g, 'N')
                .replace(/[\xD2-\xD6\xD8]/g, 'O')
                .replace(/[\xD9-\xDC]/g, 'U')
                .replace(/[\xDD]/g, 'Y')
                .replace(/[\xDE]/g, 'P')
                .replace(/[\xE0-\xE5]/g, 'a')
                .replace(/[\xE6]/g, 'ae')
                .replace(/[\xE7]/g, 'c')
                .replace(/[\xE8-\xEB]/g, 'e')
                .replace(/[\xEC-\xEF]/g, 'i')
                .replace(/[\xF1]/g, 'n')
                .replace(/[\xF2-\xF6\xF8]/g, 'o')
                .replace(/[\xF9-\xFC]/g, 'u')
                .replace(/[\xFE]/g, 'p')
                .replace(/[\xFD\xFF]/g, 'y');
        }

        return str;
    }

    /**
     * Helper to make sure that the response is an array
     * @param possibleArray
     * @returns
     */
    ensureArray(possibleArray) {

        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }

    }

}
